// Lightweight check (no content data) for routes whose head tags are owned by <SeoHead />.
const STATIC = new Set(["/", "/vds-brands", "/practitioners", "/pricing", "/about", "/anta", "/compliance-quiz", "/security", "/help", "/contact", "/privacy", "/terms", "/ai-governance", "/insights", "/compliance", "/guides"]);

export const isSeoManagedPath = (pathname: string): boolean => {
  const p = (pathname || "/").replace(/\/+$/, "") || "/";
  return STATIC.has(p) || /^\/(compliance|insights|guides)\/[^/]+$/.test(p);
};
